import { interval } from 'rxjs';
import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import Swal from 'sweetalert2';
import { UserService } from '../auth/service/user.service';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  constructor(public updates: SwUpdate, private userService: UserService) {
    if (updates.isEnabled) {
      interval(6 * 60 * 60).subscribe(() =>
        updates.checkForUpdate().then(() => {})
      );
    }
  }

  public checkForUpdates(): void {
    this.updates.versionUpdates.subscribe((event) => {
      if (event.type === 'VERSION_READY') {
        this.promptUser();
      }
    });
  }

  private promptUser(): void {
    // check if a user if logged in
    this.userService.userData.subscribe((userData: any) => {
      if (userData) {
        this.updates.activateUpdate().then(() => {
          Swal.fire({
            text: 'An updated version of Yo Scenario is available',
            toast: true,
            position: 'bottom-right',
            showConfirmButton: true,
            confirmButtonText: 'Update now',
            confirmButtonColor: '#d63384',
          }).then((result) => {
            if (result.value) {
              document.location.reload();
            }
          });
        });
      } else {
        document.location.reload();
      }
    });
  }
}
